import { useEffect } from 'react'
import { useUneeqState } from 'uneeq-react-core'
import { sendMessage } from '../../socket'
import useMayaConnect from './useMayaConnect'

const MayaUi = ({ speak }) => {
  useMayaConnect()
  const { ready } = useUneeqState()

  useEffect(() => {
    if (ready) sendMessage({ type: 'begin', speak })
  }, [speak, ready])

  if (!ready) return null
  // <Component onClick={() => sendMessage('do something')} />
  // <Component sendRequest={sendMessage} />
  return null
}

export default MayaUi
